import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitSimActiveModel } from '@apps-common/types/management/unit'

export const updateUnitActive = async (model: IUnitSimActiveModel): Promise<IUnitSimActiveModel> =>
  axios.post(`/management/unit/updateunitactive`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitSimActiveModel
}

export const useManagementUpdateUnitActive = (notify?: boolean, onSuccess?: (data: IUnitSimActiveModel) => void) =>
  useMutation({
    mutationKey: ['updateUnitActive'],
    mutationFn: ({ model }: Props) => updateUnitActive(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated device.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update device, please try again.')
      }
    },
    throwOnError: false
  })
